import { find } from './util';
var transfomers = {};
export var CustomTransformerRegistry = {
    register: function (transformer) {
        transfomers[transformer.name] = transformer;
    },
    findApplicable: function (v) {
        return find(transfomers, function (transformer) { return transformer.isApplicable(v); });
    },
    findByName: function (name) {
        return transfomers[name];
    }
};
//# sourceMappingURL=custom-transformer-registry.js.map